import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'MAINTENANCE_ISSUES',
    itemActionName: 'MAINTENANCE_ISSUE',
});
